import routeMap from './route-map.json';

export default routeMap;
export const hashIndexed = routeMap.reduce(
  (acc, cur) => ({ ...acc, [cur.hash.short]: cur }),
  {}
);
